module.exports = __webpack_public_path__ + "statics/img/wusousuo.2701a8f2.png";